import { BASE_URL_ONLINE_DOCS, DOC_HOST, DOCS_HOST, WECOM_DOC_HOST, } from '../../../base/constants/cgi-base';
// 退出登录
export var LOGOUT = "".concat(DOC_HOST, "/session/logout");
// 解绑账号
export var ACCOUNT_USER_UNBIND = "".concat(BASE_URL_ONLINE_DOCS, "user_unbind");
// 绑定账号
export var ACCOUNT_USER_BIND = "".concat(BASE_URL_ONLINE_DOCS, "user_bind");
// 判断微信用户是否已经登录或者绑定的进度
export var POLLING = "".concat(DOC_HOST, "/v2/cgi-bin/online_docs/polling");
// 微信绑定二维码
export var WXQRCODE = "".concat(DOC_HOST, "/cgi-bin/online_docs/wxqrcode");
export var WECOM_LOGOUT = "".concat(WECOM_DOC_HOST, "/session/logout");
export var DISK_LOGOUT = "".concat(WECOM_DOC_HOST, "/disklogin/logout");
export var DOCS_LOGOUT = "".concat(DOCS_HOST, "/session/logout");
export var USER_INFO_CGI = "".concat(BASE_URL_ONLINE_DOCS, "user_info");
// 查询当前登录的账号的绑定信息。
export var LOGIN_ACCOUNT_INFO = "".concat(BASE_URL_ONLINE_DOCS, "bind/permission/uid");
// 使用 QQ 登录态判断 QQ 号的绑定信息
export var BINDING_QQ_ACCOUNT_INFO = "".concat(BASE_URL_ONLINE_DOCS, "bind/permission/uin");
// 是否可以进行认证公众号操作
export var USER_CERTIFICATION_CHECK = "".concat(DOC_HOST, "/v2/user/wechat/auth/switch");
